import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LmsApi } from '@services/_api/lms-api';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { LearnershipSelectorComponent } from './../shared/components/learnership-selector/learnership-selector.component';
import { ApiHttpService } from './_api-http.service';

@Injectable({
  providedIn: 'root',
})
export class LearnershipSelectorService {
  public currentLearnershipChanged =
    new Subject<LmsApi.GetCurrentStudentsLearnershipsViewModel>();

  public currentStudentLearnership?: LmsApi.GetCurrentStudentsLearnershipsViewModel;

  public currentStudentLearnerships: LmsApi.GetCurrentStudentsLearnershipsViewModel[] =
    [];

  public get studentLearnershipSelected() {
    return this.currentStudentLearnership !== undefined;
  }

  public get selectedLearnershipName() {
    return this.currentStudentLearnership?.learnershipName;
  }

  public get isDev(): boolean {
    return this.currentStudentLearnership?.isDev ?? false;
  }

  constructor(
    private dialog: MatDialog,
    private personalClient: LmsApi.PersonalClient,
    private httpService: ApiHttpService
  ) {}

  public async openPopUp(
    disableClose: boolean = true,
    cb?: (
      selectedLearnership:
        | LmsApi.GetCurrentStudentsLearnershipsViewModel
        | null
        | undefined
    ) => void
  ) {
    await this.fetchCurrentUsersLearnerships();
    const dialogRef = this.dialog.open<
      LearnershipSelectorComponent,
      LmsApi.GetCurrentStudentsLearnershipsViewModel[],
      LmsApi.GetCurrentStudentsLearnershipsViewModel | null | undefined
    >(LearnershipSelectorComponent, {
      data: this.currentStudentLearnerships,
      minWidth: '75%',
      maxWidth: '75%',
      disableClose,
    });

    dialogRef.afterClosed().subscribe((selectedLearnership) => {
      if (selectedLearnership !== null && selectedLearnership !== undefined) {
        this.setCurrentLearnership(selectedLearnership);
      }
      if (cb) {
        cb(selectedLearnership);
      }
    });
  }

  public setMostRecentStudentLearnership() {
    const mostRecentlearnership = this.currentStudentLearnerships[0];
    if (mostRecentlearnership !== undefined) {
      this.setCurrentLearnership(mostRecentlearnership);
    }
  }

  public fetchCurrentUsersLearnerships() {
    return new Promise<LmsApi.GetCurrentStudentsLearnershipsViewModel[]>(
      (resolve, reject) => {
        this.personalClient
          .getMyStudentLearnerships()
          .pipe(take(1))
          .subscribe({
            next: (res) => {
              this.currentStudentLearnerships = res.data;
              resolve(this.currentStudentLearnerships);
            },
            error: (err) => {
              this.httpService.handle(err);
              reject(err);
            },
          });
      }
    );
  }

  public setCurrentLearnership(
    learnership: LmsApi.GetCurrentStudentsLearnershipsViewModel
  ) {
    this.currentStudentLearnership = learnership;
    this.currentLearnershipChanged.next(this.currentStudentLearnership);
  }
}
